export const sendFigmaPostMessage = (event, data) => {
  window.parent.postMessage({ type: 'send-to-figma', event, data }, '*');
};

export const validateFigmaUrl = (url) => {
  // Validates strings like https://www.figma.com/design/{KEY}/ and retrieves {KEY} if obtainable

  const pattern = /^https:\/\/www\.figma\.com\/design\/([a-zA-Z0-9-_]+)\/.*$/;
  const match = url.match(pattern);

  if (match) {
    return { isValid: true, key: match[1] };
  }
  return { isValid: false, key: null };
};
